import { createContext } from "react";

const SliderContex = createContext();

export default SliderContex;
